import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSchools } from "contexts/SchoolsContext";
import { useGetSchoolQuery } from "generated/graphql";

/**
 * Custom hook that automatically switches translation language based on the current school's isOrganization flag
 * - If isOrganization is true, uses 'enOrg' translations
 * - If isOrganization is false, uses 'en' translations
 * - Automatically falls back to 'en' if translation key is missing in 'enOrg'
 */
export const useSchoolBasedTranslation = () => {
  const { i18n } = useTranslation();
  const { currentSchool } = useSchools();

  const { data: currentSchoolData } = useGetSchoolQuery({
    variables: {
      id: currentSchool?.id || "-1",
    },
    skip: !currentSchool?.id,
  });

  useEffect(() => {
    if (currentSchoolData?.school) {
      const { isOrganization } = currentSchoolData.school;
      const targetLanguage = isOrganization ? "enOrg" : "en";

      // Only change language if it's different from current
      if (i18n.language !== targetLanguage) {
        i18n.changeLanguage(targetLanguage);
      }
    }
  }, [
    currentSchoolData?.school?.isOrganization,
    currentSchoolData?.school,
    i18n,
  ]);

  return {
    isOrganization: currentSchoolData?.school?.isOrganization ?? false,
    currentLanguage: i18n.language,
  };
};
